/**
 *
 * @param {HTMLInputElement | HTMLSelectElement} input
 */
export function hideFormInput(input) {
  const containerDiv = input.parentElement
  if (
    containerDiv?.classList.contains('input-container') ||
    containerDiv?.classList.contains('select-container')
  ) {
    const inputSectionDiv = containerDiv.parentElement
    if (inputSectionDiv) {
      inputSectionDiv.style.display = 'none'
    }
  }
}
